import React from 'react';
import PropTypes from 'prop-types';

import Button from '@components/smartAdminUI/Button';

const OfficeLookupActionButtons = ({
  officeSelected,
  currRow,
}) => {
  const handleClick = () => officeSelected(currRow);

  return (
    <div className="d-flex">
      <Button
        onClick={handleClick}
        variant="primary btn-sm"
        data-dismiss="modal"
        data-target="#officeLookupModal"
        tooltipText="Select Office"
      >
        <i className="far fa-plus" />
      </Button>
    </div>
  );
};

OfficeLookupActionButtons.propTypes = {
  currRow: PropTypes.shape({
    UniqueID: PropTypes.number,
  }),
  officeSelected: PropTypes.func.isRequired,
};

export default OfficeLookupActionButtons;
